import { GetStorageComponent } from '../../utils/storage';
import axios from '../../utils/axios';
// import { ThunkAction } from 'redux-thunk';
import { showError } from '../../utils/alertNotification';
import { AxiosRequestConfig } from 'axios';
import { GetQuizData, SaveQuizData } from '../../scenes/Students/HOC/withEntranceExam/types';

export enum ActionTypes {
  FETCH_ENTRANCE_QUIZ = 'FETCH_ENTRANCE_QUIZ',
  ENTRANCE_QUIZ_SAVE = 'ENTRANCE_QUIZ_SAVE',
}

export const getQuiz = (data: GetQuizData) => (dispatch:any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'GET',
      url: `/api/v2/entranceExam?programId=${data.programId}&batchId=${data.batchId}`,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
      'noRetry': true,
    } as AxiosRequestConfig).then((response) => {
      dispatch({
        type: ActionTypes.FETCH_ENTRANCE_QUIZ,
        payload: response.data
      });
      resolve();
    }).catch((err) => {
      if (err.data) {
        showError(err.data.message);
      }
      reject();
    });
  });
};

export const submitQuiz = (data: SaveQuizData) => (dispatch:any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'POST',
      url: `/api/v2/entranceExam`,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
      data,
      'noRetry': true,
    } as AxiosRequestConfig).then((response) => {
      resolve();
    }).catch((err) => {
      if (err.data) {
        showError(err.data.message);
      }
      reject();
    });
  });
};


export const saveQuiz = (data: SaveQuizData) => (dispatch:any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'PUT',
      url: `/api/v2/entranceExam`,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
      data,
      'noRetry': true,
    } as AxiosRequestConfig).then((response) => {
      dispatch({
        type: ActionTypes.ENTRANCE_QUIZ_SAVE,
        payload: response.data
      });
      resolve();
    }).catch((err) => {
      if (err.data) {
        showError(err.data.message);
      }
      reject();
    });
  });
};